import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoinRupees: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCoinRupees"><Path d="M7.5 10.5L16.5 10.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor"/><Path d="M9.5 7.5H11.74C13.3969 7.5 14.74 8.84315 14.74 10.5C14.74 12.1569 13.3969 13.5 11.74 13.5H9.5V13.75L14.5 17.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCoinRupees;
